import { toast } from 'react-toastify'

import { axiosCourses, axiosUser, axiosUserV5 } from './../../config/axios'
import { store } from '../../store/store'
import { identiaApi } from '../../store/api'
import { typesCounter } from './../types/typesCounter'
// import Notification, { type } from '../../components/general/toast/Toast';

export const getStudentCounter = async (
    token: string,
    obj: any,
    dispatch: any,
    setpagination?: any,
) => {
    // obj is expected to contain: entity_id, page, docs, query.search, roles
    try {
        const entityId = obj.entity_id
        const page = obj.page && Number(obj.page) > 0 ? Number(obj.page) : 1
        const docs = obj.docs && Number(obj.docs) > 0 ? Number(obj.docs) : 25
        const search = obj.query?.search || ''
        const role = Array.isArray(obj.roles) && obj.roles.length > 0 ? obj.roles[0] : 'estudiante'

        const result: any = await store.dispatch(
            identiaApi.endpoints.getEntityUsers.initiate({
                entityId,
                page,
                limit: docs,
                search,
                role,
                sortBy: 'name',
                order: 'asc',
            }),
        )

        const data = result?.data as any
        const users = data?.users || []

        const array: any[] = users.map((u: any) => {
            const attrs = u.attributes || {}
            return {
                id: u.id,
                name_student: attrs.name || attrs.nickname || '',
                lastname: attrs.lastname || '',
                email: attrs.email || '',
                photo:
                    attrs.photo && String(attrs.photo).includes('https://')
                        ? attrs.photo
                        : 'https://www.fisheries.noaa.gov/themes/custom/noaa_components/images/ProfilePic_Placeholder.jpg',
                phone: attrs.phone,
                address: attrs.address,
                dni: attrs.dni,
                roles: u.roles ? u.roles : [],
            }
        })

        // build pagination object compatible with callers
        const total = data?.total ?? users.length
        const perPage = data?.limit ?? docs
        const actualPage = data?.page ?? page
        const totalPages = perPage > 0 ? Math.max(1, Math.ceil(total / perPage)) : 1
        const hasPrevPage = actualPage > 1
        const hasNextPage = actualPage < totalPages
        const paginationObj = {
            success: true,
            total,
            actualPage,
            totalPages,
            prevPage: hasPrevPage ? actualPage - 1 : null,
            nextPage: hasNextPage ? actualPage + 1 : null,
            hasPrevPage,
            hasNextPage,
            itemCount: array.length,
        }

        dispatch({
            type: typesCounter.getUserCounter,
            payload: array,
        })

        if (setpagination) setpagination(paginationObj)

        return { data: { users: array, pagination: paginationObj } }
    } catch (e: any) {
        console.error('Error fetching users from Identia in getStudentCounter', e)
        throw e
    }
}

export const getStudentCounterCourse = async (
    token: string,
    entity_id: any,
    scheduled_id: any,
) => {
    console.log('getStudentCounterCourse')

    // 1) fetch all users from Identia via identiaApi endpoint
    const allUsers: any[] = []
    let page = 1
    let total = 0
    let limit = 0
    try {
        // initiate query via store.dispatch to use RTK Query outside components
        const result: any = await store.dispatch(
            identiaApi.endpoints.getEntityUsers.initiate({
                entityId: entity_id,
                page,
                limit,
                search: '',
                sortBy: 'name',
                order: 'asc',
            }),
        )
        const data = result?.data as any
        const usersPage = data?.users || []
        allUsers.push(...usersPage)
        total = data?.total || 0
        limit = data?.limit || 0
    } catch (e) {
        console.error('Error fetching users from Identia (RTK Query)', e)
        throw e
    }

    // 2) call legacy API to get enrolled user ids
    let enrolledIds: string[] = []
    try {
        const enr = await axiosCourses({
            url: 'v5.0.1/api',
            headers: {
                authorization: `Bearer ${token}`,
            },
            data: {
                fname: 'getEnrolledUserIds',
                entity: entity_id,
                scheduled: scheduled_id,
            },
        })
        const enrData = enr.data
        if (Array.isArray(enrData)) enrolledIds = enrData
        else if (Array.isArray(enrData?.data)) enrolledIds = enrData.data
        else if (Array.isArray(enrData?.ids)) enrolledIds = enrData.ids
        else if (Array.isArray(enrData?.userIds)) enrolledIds = enrData.userIds
    } catch (e) {
        console.error('Error fetching enrolled ids', e)
        throw e
    }

    // 3) map identia users into app shape expected by UI components
    const mapped = allUsers.map((u: any) => {
        const id = u.id
        const attrs = u.attributes || {}
        const user = {
            _id: id,
            photo:
                attrs.photo && String(attrs.photo).includes('https://')
                    ? attrs.photo
                    : 'https://www.fisheries.noaa.gov/themes/custom/noaa_components/images/ProfilePic_Placeholder.jpg',
            name: attrs.name || attrs.nickname || '',
            lastname: attrs.lastname || '',
            email: attrs.email || '',
            phone: attrs.phone,
            address: attrs.address,
            dni: attrs.dni,
        }

        return {
            user,
            roles: u.roles ? u.roles : [],
            is_enrolled: enrolledIds.includes(id),
        }
    })

    const pagination = {
        total : total,
        page: page > 1 ? page - 1 : 1,
        limit: limit,
    }

    return { data: { users: mapped, pagination } }
}

export const createUsersCounter = async (token: string, obj: any) => {
    return axiosUserV5({
        url: 'v5.0.1/api',
        headers: {
            authorization: `Bearer ${token}`,
        },
        data: obj,
    })
}

export const updateStudentCounter = async (token: string, obj: any) => {
    return axiosUserV5({
        url: 'v5.0.1/api',
        headers: {
            authorization: `Bearer ${token}`,
        },
        data: obj,
    })
}

export const deleteStudentCounter = async (
    token: string,
    id: string,
    idEntity: string,
) => {
    return axiosUserV5({
        url: 'v5.0.1/api',
        headers: {
            authorization: `Bearer ${token}`,
        },
        data: {
            fname: 'deleteUserByEntity',
            user_id: id,
            entity_id: idEntity,
        },
    })
}

export const getCoursesCounter = async (token: string) => {
    return axiosUser({
        url: 'api',
        headers: {
            authorization: `Bearer ${token}`,
        },
        data: {
            fname: 'getCourses',
            domain: 'continental',
            service: 'users',
        },
    })
}

export const getStudentsByCourses = async (token: string) => {
    return axiosUser({
        url: 'api',
        headers: {
            authorization: `Bearer ${token}`,
        },
        data: {
            fname: 'getStudentsByCourse',
            domain: 'continental',
            service: 'users',
        },
    })
}

export const getUsersByScheduleds = async (params: any) => {
    const {
        token,
        entity_id,
        currentScheduled,
        page,
        docs,
        setDataTable1,
        setpagination,
        filter_by_name,
        descendant,
    } = params

    /*
    return await axiosCourses({
        url: 'v5.0.1/api',

        headers: {
            authorization: `Bearer ${token}`,
        },

        data: {
            fname: 'getUsersByScheduled',
            scheduled: currentScheduled,
            entity: entity_id,
            filter_by_name,
            sortNameNumber: descendant === true ? -1 : 1,
            rol: 'estudiante',
            page: page,
            docs: docs,
            // query: query
        },
    })
        .then(({ data }) => {
            // console.log(data)

            let array: any[] = []

            data.users.map((dat: any) =>
                dat
                    ? array.push({
                          _id: dat.user._id,
                          photo: dat.user.photo.includes('https://')
                              ? dat.user.photo
                              : null,
                          name: dat.user.name,
                          lastname: dat.user.lastname,
                          phone: dat.user.phone,
                          dni: dat.user.dni,
                          email: dat.user.email,
                          course: dat.scheduled.course,
                          scheduled: dat.scheduled._id,
                          address: dat.user.address,
                      })
                    : null,
            )

            setpagination(data.pagination)

            setDataTable1(array)
        })
        .catch((e) => {
            console.log(e.response)

            // Notification(type.danger, "Ha ocurrido un error")
            toast.error('Ha ocurrido un error')
        })
    */

    // Obtener información del curso programado
    let scheduledInfo: any = null
    try {
        const scheduledResp = await axiosCourses({
            url: 'v5.0.1/api',
            headers: {
                authorization: `Bearer ${token}`,
            },
            data: {
                fname: 'getScheduled',
                scheduled: currentScheduled,
            },
        })
        scheduledInfo = scheduledResp.data
    } catch (err) {
        console.log('Error fetching course info', err)
        toast.error('Error al obtener información del curso')
    }

    const scheduledId =
        scheduledInfo?._id ?? scheduledInfo?.scheduled ?? scheduledInfo?.id ?? currentScheduled

    // 4) Obtener todo el listado de usuarios desde Identia (internamente paginado, devolvemos todo junto)
    try {
        const allUsers: any[] = []
        let pageIdentia = 1
        const limitIdentia = 0
        const result: any = await store.dispatch(
            identiaApi.endpoints.getEntityUsers.initiate({
                entityId: entity_id,
                page: pageIdentia,
                limit: limitIdentia,
                search: filter_by_name || '',
                role: 'estudiante',
                sortBy: 'name',
                order: descendant ? 'desc' : 'asc',
            }),
        )
        const data = result?.data as any
        const usersPage = data?.users || []
        allUsers.push(...usersPage)

        // Mapear al formato que espera la UI (igual que el bloque comentado arriba)
        // 4.a) obtener ids de usuarios matriculados en el curso
        let enrolledIds: string[] = []
        try {
            const enr = await axiosCourses({
                url: 'v5.0.1/api',
                headers: { authorization: `Bearer ${token}` },
                data: {
                    fname: 'getEnrolledUserIds',
                    entity: entity_id,
                    scheduled: scheduledId,
                },
            })
            const enrData = enr.data
            if (Array.isArray(enrData)) enrolledIds = enrData
            else if (Array.isArray(enrData?.data)) enrolledIds = enrData.data
            else if (Array.isArray(enrData?.ids)) enrolledIds = enrData.ids
            else if (Array.isArray(enrData?.userIds)) enrolledIds = enrData.userIds
        } catch (e) {
            console.error('Error fetching enrolled ids for scheduled', e)
            throw e
        }

        // 4.b) filtrar solo usuarios que pertenec al scheduled y mapear
        const array: any[] = []
        const courseName = scheduledInfo?.course?.name || scheduledInfo?.name || null

        const usersInCourse = allUsers.filter((u: any) => {
            const uid = String(u.id)
            if (enrolledIds.map(String).includes(uid)) return true
            const attrs = u.attributes || {}
            // possible places where scheduled id may be stored
            if (attrs.scheduled && String(attrs.scheduled) === String(scheduledId)) return true
            if (Array.isArray(attrs.scheduleds) && attrs.scheduleds.map(String).includes(String(scheduledId))) return true
            if (Array.isArray(attrs.scheduled_ids) && attrs.scheduled_ids.map(String).includes(String(scheduledId))) return true
            return false
        })

        usersInCourse.forEach((u: any) => {
            const attrs = u.attributes || {}
            const userObj = {
                _id: u.id,
                photo: attrs.photo && String(attrs.photo).includes('https://') ? attrs.photo : 'https://www.fisheries.noaa.gov/themes/custom/noaa_components/images/ProfilePic_Placeholder.jpg',
                name: attrs.name || attrs.nickname || '',
                lastname: attrs.lastname || '',
                phone: attrs.phone,
                dni: attrs.dni,
                email: attrs.email,
                address: attrs.address,
                scheduled: scheduledId,
            }

            array.push({
                user: userObj,
                roles: u.roles ? u.roles : [],
                is_enrolled: true,
                course: courseName,
                scheduled: scheduledId,
                _id: u.id,
                photo: userObj.photo,
                name: userObj.name,
                lastname: userObj.lastname,
                phone: userObj.phone,
                dni: userObj.dni,
                email: userObj.email,
                address: userObj.address,
            })
        })

        // Aplicar paginación manual solicitada por el caller (page, docs)
        const total = array.length
        const perPage = docs && Number(docs) > 0 ? Number(docs) : total
        const currentPage = page && Number(page) > 0 ? Number(page) : 1
        const start = (currentPage - 1) * perPage
        const paged = array.slice(start, start + perPage)

        const totalPages = perPage > 0 ? Math.max(1, Math.ceil(total / perPage)) : 1
        const hasPrevPage = currentPage > 1
        const hasNextPage = currentPage < totalPages
        const paginationObj = {
            success: true,
            total,
            actualPage: currentPage,
            totalPages,
            prevPage: hasPrevPage ? currentPage - 1 : null,
            nextPage: hasNextPage ? currentPage + 1 : null,
            hasPrevPage,
            hasNextPage,
            itemCount: paged.length,
        }

        if (setpagination) setpagination(paginationObj)
        if (setDataTable1) setDataTable1(paged)
        return { data: { users: paged, pagination: paginationObj } }
    } catch (err) {
        console.error('Error fetching all users from Identia', err)
        toast.error('Error al obtener usuarios desde Identia')
        throw err
    }
}
